// Styles
import './scss/index.scss';

// Scripts
import './javascript/index';
